export const selectStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: '28px', // sets the minimum height
    height: '31px', // fixes exact height
    padding: '0 10px', // vertical padding 0
    borderRadius: '0.4rem',
    border: state.isFocused ? '1px solid #1b8f9b' : '1px solid #ccc',
    boxShadow: state.isFocused ? '0 0 2px rgba(27, 143, 155, 0.5)' : 'none',
    fontSize: '14px',
    color: '#4b5563',
    '&:hover': {
      borderColor: state.isFocused ? '#1b8f9b' : '#ccc',
    },
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: '28px', // ensures inner content matches control
    padding: '0 6px', // optional inner padding
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    display: 'none',
  }),
  singleValue: (provided) => ({
    ...provided,
    lineHeight: '28px', // vertically center the value
    color: '#4b5563',
  }),
  placeholder: (provided) => ({
    ...provided,
    lineHeight: '28px', // vertically center placeholder
    color: '#4b5563',
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
};
